import React, { useContext } from 'react'
import { AuthContext } from '../pages/auth/AuthContext';
import { useSelector } from 'react-redux';
import tennisBallLoder from '../assets/images/tennis-ball_12128436.png'
import racketLoder from '../assets/images/loaderracket.png'
import iceSkatingImg from '../assets/images/ice-skate.gif'
import badmintonImg from '../assets/images/badminton.gif'

const Loader = () => {
  const { isLoading } = useContext(AuthContext);
  const openSlideBar = useSelector((store) => store.root.openSlideBar);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  return (
    <div className={openSlideBar || isLoading ? 'loader_container not-login' : 'loader_container'}>
      {!selectedClub?.games &&
        <>
          <div className='loader_body'>
            <img className='loader_ball' src={tennisBallLoder} alt="" />
            <img className='loader_bat' src={racketLoder} alt="" />
          </div>
          <span className="loader_new"></span>
        </>}
      {selectedClub?.games && selectedClub?.games[0]?.gameName?.toLowerCase() === 'pickleball' &&
        <>
          <div className='loader_body'>
            <img className='loader_ball' src={tennisBallLoder} alt="" />
            <img className='loader_bat' src={racketLoder} alt="" />
          </div>
          <span className="loader_new"></span>
        </>}
      {selectedClub?.games && selectedClub?.games[0]?.gameName?.toLowerCase() === 'speedskating' &&
        <img className='loader_ice_skating' src={iceSkatingImg} alt="" />
      }
       {selectedClub?.games && selectedClub?.games[0]?.gameName?.toLowerCase() === 'badminton' &&
        <img className='loader_badminton' src={badmintonImg} alt="" />
      }
    </div>
  )
}

export default Loader